import {Component, OnInit} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {Usuario} from "../../models/usuario";
import {ValidatorService} from "../../core/services/validator.service";
import {UsuarioService} from "../../services/usuario.service";
import {MessageService} from "../../core/services/message.service";
import {NgxSpinnerService} from "ngx-spinner";
import {ActivatedRoute, Router} from "@angular/router";
import {LoginService} from "../../services/login.service";
import {Perfil} from "../../models/perfil";
import {PerfilService} from "../../services/perfil.service";
import {Estado} from "../../models/estado";
import {Municipio} from "../../models/municipio";
import {EstadoService} from "../../services/estado.service";
import {MunicipioService} from "../../services/municipio.service";
import {array} from "prop-types";
import {ArquivoService} from "../../services/arquivo.service";
import {Login} from "../../models/login";
import {DialogSolicitarAcessoComponent} from "../dialogs/dialog-solicitar-acesso/dialog-solicitar-acesso.component";
import {DialogUsuarioExternoComponent} from "../dialogs/dialog-usuario-externo/dialog-usuario-externo.component";
import {DialogConfirmarExclusaoAnexoComponent} from "../dialogs/dialog-confirmar-exclusao-anexo/dialog-confirmar-exclusao-anexo.component";
import {MatDialog} from "@angular/material";
import {isUndefined} from "util";
import {GovBrService} from "../../services/govbr.service";

@Component({
    selector: 'app-usuario-externo',
    templateUrl: './usuario-externo.component.html',
    styleUrls: ['./usuario-externo.component.scss']
})
export class UsuarioExternoComponent implements OnInit {

    private usuario: Usuario;
    private user: Usuario;
    public perfis: Array<Perfil> = [];
    public form: FormGroup;
    public arquivoList: FormArray;
    public estados: Array<Estado>;
    public municipios: Array<Municipio>;
    public files = [];
    public upload_success = false;
    public nome: string;

    constructor(private usuarioService: UsuarioService,
                private perfilService: PerfilService,
                private loginService: LoginService,
                private estadoService: EstadoService,
                private messageService: MessageService,
                private loadingService: NgxSpinnerService,
                private municipioService: MunicipioService,
                private arquivoService: ArquivoService,
                private validator: ValidatorService,
                private router: Router,
                private route: ActivatedRoute,
                private govBrService: GovBrService,
                private dialog: MatDialog,
                private fb: FormBuilder) {

    }

    ngOnInit() {
        let login = this.govBrService.getLocalItem("data");

        this.usuario = new Usuario();

        this.usuarioService.findByCpf(login.sub).subscribe(usuario => {
            this.usuario = usuario;
        });
        this.nome = login.name;
        this.form = this.fb.group({
            arquivo: this.fb.array([this.createArquivo()])
        });

        this.arquivoList = this.form.get('arquivo') as FormArray;
    }

    get arquivoFormGroup() {
        return this.form.get('arquivo') as FormArray;
    }

    createArquivo(): FormGroup {
        return this.fb.group({
            arquivo: [null, Validators.required]
        });
    }

    addArquivoExterno() {
        this.arquivoList.push(this.createArquivo());
    }

    deleteArquivoExterno(index) {
        this.arquivoList.removeAt(index);
    }

    prepareUpload(event): void {
        let arquivo = event.target.files[0];
        this.files.push(arquivo);
    }

    save(): void {
        if (this.form.valid) {
            let formdata = new FormData();
            this.files.forEach(file => {
                if (file.size > 20000000) {
                    this.messageService.showError("Arquivo superior a 20MB");
                    return false;
                }
                formdata.append('arquivos[]', file, file.name);
            });

            formdata.append('cod_usuario', this.usuario.cod_usuario.toString());

            this.arquivoService.uploadFileUsuario(formdata)
                .subscribe(data => {
                    this.messageService.showSuccess("Anexo Salvo com sucesso");
                    this.arquivoList.reset();
                });
        }
    }


    downloadSolicitacao(): void {
        this.usuarioService.solicitacaoDownload(this.usuario.cod_usuario);
    }

    modal(): boolean {
        let dialog: any = this.dialog.open(DialogUsuarioExternoComponent, {
            width: '600px',
            data: {
                item: this.usuario
            }
        });

        dialog.afterClosed().subscribe((result: any) => {
            let pode_cancelar: boolean = result.salvar;
            if (pode_cancelar) {
                this.messageService.showSuccess("Usuario alterado com sucesso");
            }else {
                this.messageService.showSuccess("Usuario alterado com sucesso");
            }
        });
        return false;
    }
}
